// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2JgZ4","fieldsContainer":"styles_fieldsContainer__3JpUF","field":"styles_field__13aDU","queryId":"styles_queryId__3LWKx"};